
// import Vue from 'vue'
// import axios from 'axios'
export default {
  data(){
      return{
      myVariable:10,
      }
  },
  methods: {
    async getUserRoot() {
        let usuario = JSON.parse(localStorage.getItem("usuario"))[0]
        try {
            const resultado = await this.$http.get(this.$server_url + 'permisos/' + usuario.idusuario)
            return resultado
          } catch (error) {
            return error
          }
    },
    async f_notificaciones(mensaje="Ingresar mensaje", color="success", icono="icon-check",time="4000") {
      let me = this;
      me.$vs.notify({
          text: mensaje,
          color: color,
          iconPack: 'feather',
          icon: icono,
          time: time
      })
      return;
    }
   
  },
};
